import React from 'react';
import { CardTitle, CardText} from 'material-ui/Card';
import {RadioButton, RadioButtonGroup} from 'material-ui/RadioButton';
import PropTypes from 'prop-types';
import {FormattedMessage, injectIntl} from "react-intl";

const RepresentationCategoryDetail = ({category, section}) => {
  if (section === 'Data Collection' || section === 'monitoring') {
    switch (category) {
      case "Neither":
      case "":
      case null:
      case undefined:
      case false:
        return <CardText>&nbsp;</CardText>
      case "Both":
        return <CardText style={{maxWidth:400}}><FormattedMessage id="questionPage.bothRepImpl" defaultMessage="This question pertains to both representation and implementation." /></CardText>
      case "Implementation":
        return <CardText style={{maxWidth:400}}><FormattedMessage id="questionPage.bothRepImpl" defaultMessage="This question pertains to issues of implementation." /></CardText>
      case "Representation":
        return <CardText style={{maxWidth:400}}><FormattedMessage id="questionPage.bothRepImpl" defaultMessage="This question pertains to issues of representation." /></CardText>
      default:
        return <CardText>&nbsp;</CardText>
    }
  } else {
    return <CardText>&nbsp;</CardText>
  }
}

const onTextClick = (e) => {
  if (e.target.href) {
    window.open(e.target.href, '_blank');
    e.preventDefault();
  }
}

class QuestionPrompt extends React.Component {
  render() {
    let props = this.props;
    const value = props.answer && typeof props.answer === "object" ? props.answer.value : props.answer;
    let qTitle = props.title;
    let qDesc = props.description;
    let answers = props.answers;
    if(props.trQuestion){
      qTitle = props.trQuestion.title
      qDesc = props.trQuestion.description
      answers = props.trQuestion.answers
    }
    return (
      <div>
        <RepresentationCategoryDetail category={props.representationCategory} section={props.section}/>
        <CardTitle style={{fontWeight: '500', paddingBottom:0}} title={<div dangerouslySetInnerHTML={{__html: qTitle}} />} />
        <CardText style={{fontSize:16, paddingTop:0}} onClick={onTextClick}><div dangerouslySetInnerHTML={{__html: qDesc}} /></CardText>
        <CardText>
        <RadioButtonGroup ref="radioGroup" valueSelected={value} onChange={props.onChange} name="answer">
          {
            answers.map((answer) => (
              <RadioButton
                key={answer.id}
                value={answer.id}
                label={answer.title}
                disabled={props.readOnly}
                labelStyle={props.readOnly ? {color: 'black', fontSize:16} : {fontSize:16}}
              />
            ))
          }
        </RadioButtonGroup>
        </CardText>
      </div>
    )
  }

  getValue() {
    let selected = this.refs.radioGroup.state.selected;
    let answer = this.props.answers.find((a) => a.id === selected);
    if (answer) {
      return answer.id;
    } else {
      return null;
    }
  }
}

QuestionPrompt.propTypes = {
  answers: PropTypes.array.isRequired
}

export default injectIntl(QuestionPrompt, {forwardRef:true});
